import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue";
const _hoisted_1 = { class: "filter-bar justify-between" };
const _hoisted_2 = {
    key: 0,
    class: "filter-options"
};
const _hoisted_3 = { class: "d-flex data-grid-action-buttons" };
const _hoisted_4 = {
    key: 1,
    class: "export-options"
};
const _hoisted_5 = {
    key: 2,
    class: "divider"
};
const _hoisted_6 = {
    key: 3,
    class: "adding-options"
};
const _hoisted_7 = {
    key: 4,
    class: "action-button"
};
const _hoisted_8 = {
    key: 5,
    class: "export-options"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($props.showFilterOptions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode($setup["EnTooltip"], {
                    location: "bottom",
                    text: ""
                }, {
                    default: _withCtx(() => [
                        _createVNode($setup["EnFilterVisibilityMenu"], {
                            "filter-buttons": $props.filterButtons,
                            "reset-filters": $setup.handleResetFilter,
                            "reset-individual-filter": $props.resetIndividualFilter
                        }, null, 8 /* PROPS */, ["filter-buttons", "reset-individual-filter"])
                    ]),
                    _: 1 /* STABLE */
                })
            ]))
            : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_3, [
            ($props.showColumnsButton)
                ? (_openBlock(), _createBlock($setup["EnColumnVisibilityMenu"], {
                    key: 0,
                    columns: $props.columns,
                    "show-all-columns": $props.showAllColumns,
                    "restore-default-view": $props.restoreDefaultView,
                    showRestoreDefaultViewButton: $props.showRestoreDefaultViewButton,
                    "reorder-columns": $props.reorderColumns,
                    toggleVisibilityColumn: $props.toggleVisibilityColumn,
                    "static-id": $props.staticId,
                    onColumnsShowAll: $props.showAllColumns,
                    onColumnToggled: $props.toggleVisibilityColumn
                }, null, 8 /* PROPS */, ["columns", "show-all-columns", "restore-default-view", "showRestoreDefaultViewButton", "reorder-columns", "toggleVisibilityColumn", "static-id", "onColumnsShowAll", "onColumnToggled"]))
                : _createCommentVNode("v-if", true),
            ($props.showExportButton)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode($setup["EnButton"], {
                        class: "export-button data-grid-action-button",
                        "static-id": $setup.getIdForItem('export-all-button'),
                        tooltip: $setup.t('common.dataGrid.exportAll.label'),
                        "tooltip-location": "bottom",
                        onClick: $props.exportAllData
                    }, {
                        prepend: _withCtx(() => [
                            _createVNode($setup["EnExportIcon"])
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString($setup.t('common.dataGrid.exportButtonText')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["static-id", "tooltip", "onClick"])
                ]))
                : _createCommentVNode("v-if", true),
            ($props.allowAdding && !$props.dense)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                : _createCommentVNode("v-if", true),
            ($props.allowAdding && !$props.dense)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode($setup["EnButton"], {
                        class: "data-grid-action-button",
                        tooltip: $setup.t('common.dataGrid.addNewAccount'),
                        "tooltip-location": "bottom",
                        "static-id": $setup.getIdForItem('add-new-item-button'),
                        onClick: $props.addItem
                    }, {
                        prepend: _withCtx(() => [
                            _createVNode($setup["Plus"])
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString($setup.t('common.dataGrid.add')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["tooltip", "static-id", "onClick"])
                ]))
                : _createCommentVNode("v-if", true),
            ($setup.slots.datagridActions)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "divider" }, null, -1 /* CACHED */)),
                    _renderSlot(_ctx.$slots, "datagridActions", {}, undefined, true)
                ]))
                : _createCommentVNode("v-if", true),
            false
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode($setup["EnMenu"], {
                        absolute: "",
                        "offset-y": "",
                        left: ""
                    }, {
                        trigger: _withCtx(() => [
                            _createVNode($setup["EnIcon"], {
                                class: "ml-4",
                                id: "button-open-settings-menu"
                            }, {
                                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                        _createTextVNode("mdi mdi-cog", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("div", null, [
                                ($props.showExportButton)
                                    ? (_openBlock(), _createBlock($setup["EnItem"], {
                                        key: 0,
                                        onClick: _cache[0] || (_cache[0] = event => $props.exportData())
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", null, [
                                                _createVNode($setup["Download"], {
                                                    class: "mr-4",
                                                    id: "button-download-data-grid-selected"
                                                }),
                                                _createTextVNode(" " + _toDisplayString($props.exportToExcelSelectedValuesButtonText), 1 /* TEXT */)
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _createVNode($setup["EnItem"], { onClick: $props.exportAllData }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", null, [
                                            _createVNode($setup["Download"], {
                                                class: "mr-4",
                                                id: "button-download-data-grid-all"
                                            }),
                                            _createTextVNode(" " + _toDisplayString($setup.t('common.dataGrid.exportAll.label')), 1 /* TEXT */)
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onClick"])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]))
                : _createCommentVNode("v-if", true),
            ($props.showActionButton)
                ? (_openBlock(), _createBlock($setup["EnDataGridActionsMenu"], {
                    key: 6,
                    "static-id": $setup.getIdForItem('actions-menu')
                }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                    ($setup.slots.moduleSpecificActions)
                        ? {
                            name: "moduleSpecificActions",
                            fn: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "moduleSpecificActions", {}, undefined, true)
                            ]),
                            key: "0"
                        }
                        : undefined,
                    ($setup.slots.batchProcessActions)
                        ? {
                            name: "batchProcessActions",
                            fn: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "batchProcessActions", {}, undefined, true)
                            ]),
                            key: "1"
                        }
                        : undefined
                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["static-id"]))
                : _createCommentVNode("v-if", true)
        ])
    ]));
}
